import moment from 'moment'
import { GENDER_FEMALE, GENDER_MALE, SITE_BASE_URL } from '@/config'

export default class UserChild {
  constructor (data, parent, index = 0) {
    if (!data.id) throw new Error('Invalid UserChild data.')

    this.id = +data.id
    this.index = index
    this.firstName = data.first_name ?? ''
    this.gender = data.gender ?? GENDER_FEMALE
    // this.avatarUrl = data.avatar ??
    //   (this.gender === GENDER_FEMALE ? `${SITE_BASE_URL}/assets/images/avatars/girl.svg`
    //     : this.gender === GENDER_MALE ? `${SITE_BASE_URL}/assets/images/avatars/boy.svg` : '')

    this.birthDate = data.birth_date ? moment(data.birth_date) : null

    this.isDefault = data.is_default ?? null

    this.parent = parent
  }

  get avatarUrl () {
    const avatarName = `kid-${(this.index + 1) % 5}`
    return `${SITE_BASE_URL}assets/images/avatars/${avatarName}.svg`
  }

  get genderText () {
    switch (this.gender) {
      default:
      case GENDER_FEMALE:
        return 'Женский'
      case GENDER_MALE:
        return 'Мужской'
    }
  }
}
